import i18n from '@i18n';
import { FuseNavItemType } from '@fuse/core/FuseNavigation/types/FuseNavItemType';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';

i18n.addResourceBundle('en', 'navigation', en);
i18n.addResourceBundle('tr', 'navigation', tr);
i18n.addResourceBundle('ar', 'navigation', ar);

/**
 * Full menu in display order. Keep the logout item last.
 *
 * 2026-07-29: Phase 2 nav gating (`requiresFeature` + NEXT_PUBLIC_FEATURE_* flags) was
 * removed — all Phase 2 features are now on for every user. No nav item was actually
 * gated at the time of removal; the mechanism only existed as a commented-out example.
 */
const allNavigation: FuseNavItemType[] = [
  {
    id: 'invoices',
    title: 'Invoices',
    type: 'item',
    icon: 'lucide:file-text',
    url: '/invoices',
  },
  {
    id: 'email-config',
    title: 'Email Configuration',
    type: 'item',
    icon: 'lucide:mail',
    url: '/email-config',
  },
  {
    // KAIROSTSAP-111 — moved out of admin/comps/[id]/config per Iwan's 27 Aug ask: "the history
    // one you move up to public". Visible to every authenticated user, same as Invoices/Email
    // Configuration above — GET /api/sync/runs already authorises per-company on its own.
    id: 'sync-history',
    title: 'Sync History',
    type: 'item',
    icon: 'lucide:history',
    url: '/sync-history',
  },
  {
    id: 'help',
    title: 'Help & User Guide',
    type: 'item',
    icon: 'lucide:circle-help',
    url: '/help',
  },
  {
    id: 'admin',
    title: 'Administration',
    type: 'group',
    icon: 'lucide:settings',
    children: [
      {
        id: 'admin-dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'lucide:layout-dashboard',
        url: '/admin/dashboard',
      },
      {
        id: 'admin-orgs',
        title: 'Organizations',
        type: 'item',
        icon: 'lucide:building-2',
        url: '/admin/korgs',
      },
      {
        id: 'admin-companies',
        title: 'Companies',
        type: 'item',
        icon: 'lucide:briefcase',
        url: '/admin/comps',
      },
      {
        id: 'admin-users',
        title: 'Users',
        type: 'item',
        icon: 'lucide:users',
        url: '/admin/users',
      },
    ],
  },

  // ---- Phase 2 (feature-flagged) menu items go here, before Logout ----
  // e.g. { id: 'bulk-send', title: 'Bulk Send', type: 'item', icon: 'lucide:send',
  //        url: '/bulk-send', requiresFeature: 'bulkSend' },

  {
    id: 'logout',
    title: 'Logout',
    type: 'item',
    icon: 'lucide:log-out',
    url: '/auth/sign-out',
  },
];

const navigationConfig: FuseNavItemType[] = allNavigation;

export default navigationConfig;
